import {
  TransferInstructionContextType,
  useTransferInstructionContext,
} from '@hooks/mutations/allocation/useTransferInstructionContext';
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { ChoiceContext } from '@daml.js/splice-api-token-metadata/lib/Splice/Api/Token/MetadataV1';
import {
  TransferInstruction,
  TransferInstruction_Withdraw,
} from '@daml.js/splice-api-token-transfer-instruction/lib/Splice/Api/Token/TransferInstructionV1';
import { ContractId } from '@daml/types';
import { toTokenStandardDisclosedContract } from '../../../../utils/common';
import { ERR_REJECT_INSTRUCT_XFER, SUC_REJECT_INSTRUCT_XFER } from '../../../../utils/strings';

interface Args {
  registrar: string;
  transferCid: ContractId<TransferInstruction>;
  reason?: string;
}
export const useRejectTransferInstruction = () => {
  const { submit: rejectTransferInstruction } = useExerciseSubmission(
    TransferInstruction.TransferInstruction_Reject,
    SUC_REJECT_INSTRUCT_XFER,
    ERR_REJECT_INSTRUCT_XFER,
  );
  const getTransferInstructionAcceptContext = useTransferInstructionContext(
    TransferInstructionContextType.Reject,
  );
  const reject = async (args: Args) => {
    const { registrar, transferCid, reason } = args;
    const rejectTransferInstructContext = await getTransferInstructionAcceptContext.mutateAsync({
      registrar,
      transferInstructionCid: transferCid,
    });

    const payload: TransferInstruction_Withdraw = {
      extraArgs: {
        context: rejectTransferInstructContext.choiceContextData as ChoiceContext,
        meta: { values: { 'splice.lfdecentralizedtrust.org/reason': reason || '' } },
      },
    };
    const disclosedContracts =
      rejectTransferInstructContext.disclosedContracts.map(toTokenStandardDisclosedContract) || [];
    await rejectTransferInstruction({
      cid: transferCid,
      argument: payload,
      disclosedContracts,
    });
  };
  return reject;
};
